import { observer } from "mobx-react";
import React from "react";
import OfferIcon from "@components/icons/Offer";
import { useTranslation } from "react-i18next";
import { ChatMessageType } from "@data-types/chat";
import { useRootAppStore } from "@hooks";

export default observer(function ChatReplayMessagePreview() {
	const { t } = useTranslation();
	const rootStore = useRootAppStore();

	if (!rootStore.chatViewStore.selectedMessageToReplyOn) {
		return null;
	}

	const creatorId =
		rootStore.chatViewStore.selectedMessageToReplyOn.creatorId !==
		rootStore.userAuthStore.user?.chatName
			? rootStore.chatViewStore.selectedMessageToReplyOn.creatorId
			: `${t("CHAT.REPLIED_TO_NAME")}`;

	if (
		!rootStore.chatViewStore.selectedMessageToReplyOn.data.betSlipData &&
		!rootStore.chatViewStore.selectedMessageToReplyOn.data.sharedSlip
	) {
		return (
			<div className="chat__reply">
				<div className="chat__reply__header">
					<span className="chat__reply__username">{creatorId}:</span>
					<div
						className="chat__btn--remove btn btn--square btn--square--xtny btn--ghost"
						onClick={() => {
							rootStore.chatViewStore.setSelectedMessageToReplyOn(
								null
							);
						}}
					>
						<i className="u-icon u-icon--tny u-icon--close" />
					</div>
				</div>

				<div className="chat__reply__message">
					{
						rootStore.chatViewStore.selectedMessageToReplyOn.data
							?.text
					}
				</div>
			</div>
		);
	}

	if (
		rootStore.chatViewStore.selectedMessageToReplyOn.data.sharedSlip &&
		rootStore.chatViewStore.selectedMessageToReplyOn.data.betSlipData
	) {
		const {
			eventCount,
			maxCoefficient,
			dateCreated,
			sportAbrv,
			firstEventName,
		} = rootStore.chatViewStore.selectedMessageToReplyOn.data.betSlipData;

		const isMultiOffer =
			rootStore.chatViewStore.selectedMessageToReplyOn.data?.betSlipData
				.hasBetBuilder;

		return (
			<div className="chat__reply">
				<div className="chat__reply__header">
					<span className="chat__reply__username">{creatorId}:</span>

					<div
						className="chat__btn--remove btn btn--square btn--square--xtny btn--ghost"
						onClick={() =>
							rootStore.chatViewStore.setSelectedMessageToReplyOn(
								null
							)
						}
					>
						<i className="u-icon u-icon--tny u-icon--close" />
					</div>
				</div>

				<div className="chat__reply__message">
					{rootStore.chatViewStore.selectedMessageToReplyOn.data.text}
				</div>

				<div className="chat__reply__slip">
					<div className="chat__slip__header">
						<OfferIcon
							type="sport"
							sport={sportAbrv}
							className="chat__icon__primary u-icon u-icon--lrg"
						/>
						{isMultiOffer && (
							<i className="u-icon u-icon--bb--active u-icon--med"></i>
						)}
						<span className="chat__slip__count">{eventCount}</span>
						<span className="chat__slip__title">
							{firstEventName}
						</span>
					</div>

					<div className="chat__slip__footer">
						<span>
							{t("BET_SLIP.MAX_COEF")}:{" "}
							<strong>{maxCoefficient}</strong>
						</span>
						<span className="u-color--text--tertiary">
							{dateCreated}
						</span>
					</div>
				</div>
			</div>
		);
	}

	if (
		rootStore.chatViewStore.selectedMessageToReplyOn.data.messageType ==
			ChatMessageType.REPLY &&
		rootStore.chatViewStore.selectedMessageToReplyOn.data.sharedSlip &&
		!rootStore.chatViewStore.selectedMessageToReplyOn.data.betSlipData
	) {
		return (
			<div className="chat__reply">
				<div className="chat__reply__header">
					<span className="chat__reply__username">{creatorId}:</span>

					<div
						className="chat__btn--remove btn btn--square btn--square--xtny btn--ghost"
						onClick={() => {
							rootStore.chatViewStore.setSelectedMessageToReplyOn(
								null
							);
						}}
					>
						<i className="u-icon u-icon--tny u-icon--close" />
					</div>
				</div>

				<div className="chat__reply__message">
					{
						rootStore.chatViewStore.selectedMessageToReplyOn.data
							?.text
					}
				</div>
			</div>
		);
	}

	if (
		rootStore.chatViewStore.selectedMessageToReplyOn.data.messageType !=
			ChatMessageType.REPLY &&
		rootStore.chatViewStore.selectedMessageToReplyOn.data.sharedSlip &&
		!rootStore.chatViewStore.selectedMessageToReplyOn.data.betSlipData
	) {
		const {
			eventCount,
			maxCoefficient,
			dateCreated,
			sportAbrv,
			firstEventName,
		} = rootStore.chatViewStore.selectedMessageToReplyOn.data.sharedSlip;

		const messageText =
			rootStore.chatViewStore.selectedMessageToReplyOn.data.text;

		const isMultiOffer =
			rootStore.chatViewStore.selectedMessageToReplyOn.metadata
				?.isMultiOffer;

		return (
			<div className="chat__reply">
				<div className="chat__reply__header">
					<span className="chat__reply__username">{creatorId}:</span>

					<div
						className="chat__btn--remove btn btn--square btn--square--xtny btn--ghost"
						onClick={() =>
							rootStore.chatViewStore.setSelectedMessageToReplyOn(
								null
							)
						}
					>
						<i className="u-icon u-icon--tny u-icon--close" />
					</div>
				</div>
				<div className="chat__reply__message">{messageText}</div>

				<div className="chat__reply__slip">
					<div className="chat__slip__header">
						<OfferIcon
							type="sport"
							sport={sportAbrv}
							className="chat__icon__primary u-icon u-icon--lrg"
						/>
						{isMultiOffer && (
							<i className="u-icon u-icon--bb--active u-icon--med"></i>
						)}
						<span className="chat__slip__count">{eventCount}</span>
						<span className="chat__slip__title">
							{firstEventName}
						</span>
					</div>

					<div className="chat__slip__footer">
						<span>
							{t("BET_SLIP.MAX_COEF")}:{" "}
							<strong>{maxCoefficient}</strong>
						</span>
						<span className="u-color--text--tertiary">
							{dateCreated}
						</span>
					</div>
				</div>
			</div>
		);
	}

	if (
		!rootStore.chatViewStore.selectedMessageToReplyOn.data.sharedSlip &&
		rootStore.chatViewStore.selectedMessageToReplyOn.data.betSlipData
	) {
		const {
			eventCount,
			maxCoefficient,
			dateCreated,
			sportAbrv,
			firstEventName,
		} = rootStore.chatViewStore.selectedMessageToReplyOn.data.betSlipData;

		const isMultiOffer =
			rootStore.chatViewStore.selectedMessageToReplyOn.data.betSlipData
				?.hasBetBuilder;

		const messageText =
			rootStore.chatViewStore.selectedMessageToReplyOn.data.text;

		return (
			<div className="chat__reply">
				<div className="chat__reply__header">
					<span className="chat__reply__username">{creatorId}</span>

					<div
						className="chat__btn--remove btn btn--square btn--square--xtny btn--ghost"
						onClick={() =>
							rootStore.chatViewStore.setSelectedMessageToReplyOn(
								null
							)
						}
					>
						<i className="u-icon u-icon--tny u-icon--close" />
					</div>
				</div>

				<div className="chat__reply__message">{messageText}</div>

				<div className="chat__reply__slip">
					<div className="chat__slip__header">
						<OfferIcon
							type="sport"
							sport={sportAbrv}
							className="chat__icon__primary u-icon u-icon--lrg"
						/>
						{isMultiOffer && (
							<i className="u-icon u-icon--bb--active u-icon--med"></i>
						)}
						<span className="chat__slip__count">{eventCount}</span>
						<span className="chat__slip__title">
							{firstEventName}
						</span>
					</div>

					<div className="chat__slip__footer">
						<span>
							{t("BET_SLIP.MAX_COEF")}:{" "}
							<strong>{maxCoefficient}</strong>
						</span>
						<span className="u-color--text--tertiary">
							{dateCreated}
						</span>
					</div>
				</div>
			</div>
		);
	}

	return <></>;
});
